interface NavigatorUAData {
  platform: string;
  // Add other properties as needed
}

declare global {
  interface Navigator {
    userAgentData?: NavigatorUAData;
  }
}

export const isMacOS = () => {
  // Check using userAgentData first if available
  if ('userAgentData' in navigator && navigator.userAgentData?.platform) {
    return navigator.userAgentData.platform.toUpperCase().includes('MACOS');
  }

  // Fallback to traditional checks
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.userAgent.toUpperCase().indexOf('MAC') >= 0;
};
